<template>
  <div id="sendPicker">
    <model v-if="newShowModel" :buttonType="0" :title='title ()' :minWidth="'600px'" :min-height="'500px'"  v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
       <div class="left_title">推送类别</div>
       <div class="t_selects">
         <selects
         @va="sunValue"
         num="3"
         :selects1="selects1"
         :selects2="selects2"
         :selects3="selects3"
         ></selects>
 </div>

    </model>

  </div>
</template>

<script>
// import newPage from './page'
export default {
  name: 'page',
  model: {
    prop: 'newShowModel',
    event: 'newShowModel'
  },
  props: [
    'newShowModel'
  ],
  data () {
    return {
      selects1: '文本',
      selects2: '图片',
      selects3: '图文消息'
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    this.getAllUser(1)
  },
  methods: {
    getAllUser (page) {

    },
    cancelModel () {
      this.$emit('newShowModel', false)
    },
    confirModel () {
      this.$emit('newShowModel', false)
      let dataList = {
        chooseUserIdList: this.chooseUserIdList,
        chooseUserList: this.chooseUserList
      }
      this.$emit('choosedConfirm', dataList)
    },
    title () {
      return '新建推送'
    }
  }
}
</script>

<style scoped>
.t_selects{
  height: 170px;
  margin-top: 40px;
  width: 250px;
  margin-left: 200px;
  margin-top: 30px;
}
.left_title{
  margin-top: 30px;
  font-size: 15px;
  margin-left:120px;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/myComponents/sendPicker.vue